export const initialFilterFormData = {
  group_ids: null as any,
  notWorking: false,
};
